import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";

const LocationsSection = () => {
  return (
    <Box sx={{ backgroundColor: "#fbf8f2", py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        {/* HEADER */}
        <Box textAlign="center" mb={6}>
          <Typography
            sx={{
              color: "#ff8a00",
              fontWeight: 600,
              letterSpacing: "1px",
              mb: 1,
            }}
          >
            Get in touch
          </Typography>

          <Typography variant="h4" fontWeight={700}>
            Locations We Serve
          </Typography>
        </Box>

        {/* MAP CONTAINER */}
        <Box
          sx={{
            position: "relative",
            borderRadius: "28px",
            overflow: "hidden",
            backgroundColor: "#d6e2de",
            height: { xs: 420, md: 380 },
          }}
        >
          {/* GOOGLE MAP */}
          <Box
            component="iframe"
            src="https://www.google.com/maps?q=Bloomington,Indiana&output=embed"
            sx={{
              width: "100%",
              height: "100%",
              border: 0,
              filter: "grayscale(100%)",
            }}
            loading="lazy"
          />

          {/* ORANGE INFO CARD */}
          <Box
            sx={{
              position: "absolute",
              left: { xs: 16, md: 32 },
              top: { xs: 16, md: 32 },
              backgroundColor: "#ff8a00",
              color: "#fff",
              borderRadius: "24px",
              p: 4,
              width: { xs: "85%", sm: 320 },
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
          >
            <LocationOnIcon sx={{ fontSize: 32 }} />

            <Typography variant="h6" fontWeight={700} mt={2}>
              Bloomington, IN*
            </Typography>

            <Typography mt={1} fontSize={14}>
              Bloomington, Indiana 47401
            </Typography>

            <Box display="flex" alignItems="center" mt={2}>
              <PhoneIcon sx={{ fontSize: 18, mr: 1 }} />
              <Typography fontSize={14}>
                (812) 555-0247
              </Typography>
            </Box>

            <Typography
              mt={2}
              fontSize={12}
              sx={{ opacity: 0.9 }}
            >
              *Serving Bloomington and nearby areas.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LocationsSection;
